import { SITE_URL } from '@/mocks/site';

const SITE_ORIGIN = (import.meta.env.VITE_SITE_URL as string | undefined) || SITE_URL;

export const SITE_NAME = 'USFansLink';

export const LOGO_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg';

const organization = {
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_ORIGIN,
  logo: LOGO_URL,
};

const homeFaq = [
  {
    '@type': 'Question',
    name: 'Is USFansLink the official USFans website?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'No. USFansLink is an independent resource hub. We collect and organize links and guides, but all purchases happen on the main website.',
    },
  },
  {
    '@type': 'Question',
    name: 'How do I use the category dropdown?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Open the dropdown, choose a category, and you will be taken directly to the matching section on the main website.',
    },
  },
  {
    '@type': 'Question',
    name: 'Where can I find shipping and coupon information?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Shipping details, coupons and discount codes are updated by the main website. We point you to the right category and recommend confirming the final price before checkout.',
    },
  },
  {
    '@type': 'Question',
    name: 'Do you sell products directly?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'No. We do not sell or ship any products. All orders are handled by the main website.',
    },
  },
];

const articleFaq = [
  {
    '@type': 'Question',
    name: 'Is this guide official?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'No. This is an independent guide created to help you research the USFans spreadsheet safely.',
    },
  },
  {
    '@type': 'Question',
    name: 'Do I buy directly from the spreadsheet?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'No. The spreadsheet points you to products, but all purchases are completed on the main website.',
    },
  },
  {
    '@type': 'Question',
    name: 'How often is the spreadsheet updated?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Update frequency can vary. Always confirm current prices, stock and shipping on the main website before ordering.',
    },
  },
];

export function buildHomeJsonLd(): object[] {
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_ORIGIN,
      description:
        'Explore USFans spreadsheet resources, seller guides, product research, shipping information, warehouse guides, reviews, coupons and safety tips.',
      inLanguage: 'en',
      publisher: organization,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_ORIGIN,
      logo: LOGO_URL,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: homeFaq,
    },
  ];
}

export function buildArticleJsonLd(): object[] {
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: 'USFans Spreadsheet: Complete Resource & Research Guide',
      description:
        'A practical guide to the USFans spreadsheet — how it works, how to use categories, what to check before buying, and safety basics.',
      image: LOGO_URL,
      author: organization,
      publisher: organization,
      mainEntityOfPage: `${SITE_ORIGIN}/usfans-spreadsheet-guide`,
      datePublished: '2026-08-20',
      dateModified: '2026-08-20',
      inLanguage: 'en',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: articleFaq,
    },
  ];
}